/**
 * Append CDN image resize query param (`width=N`).
 * Uses `&` when the URL already has a query string.
 */
export function withCdnImageWidth(url: string, width: number): string {
  const sep = url.includes('?') ? '&' : '?'
  return `${url}${sep}width=${width}`
}
